import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@material-ui/lab';
import { useAuthStore } from '../AuthStore';

function humanReadableDuration(msDuration: number): string {
  const h = Math.floor(msDuration / 1000 / 60 / 60);
  const m = Math.floor((msDuration / 1000 / 60 / 60 - h) * 60);
  const s = Math.floor(((msDuration / 1000 / 60 / 60 - h) * 60 - m) * 60);

  // To get time format 00:00:00
  const seconds: string = s < 10 ? `0${s}` : `${s}`;
  const minutes: string = m < 10 ? `0${m}` : `${m}`;
  const hours: string = h < 10 ? `0${h}` : `${h}`;

  return `${hours}h ${minutes}m ${seconds}s`;
}

const AuthTimeoutDisplay = (): React.ReactElement => {
  const store = useAuthStore();
  const [msUntilExpiry, setMsUntilExpiry] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setMsUntilExpiry(store.millisecondsUntilExpiry)
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Alert severity="info">Time until expiry: {humanReadableDuration(msUntilExpiry)}</Alert>
  );
}

export default observer(AuthTimeoutDisplay);
